<template>
  <SubNavbar :items="navItems" />
</template>

<script setup lang="ts">
import { computed } from 'vue';
import SubNavbar from '@/components/ui/SubNavbar.vue';

const navItems = computed(() => [
  { path: '/orders', label: 'Pedidos' },
  { path: '/kitchen', label: 'Cocina' },
  { path: '/tables', label: 'Mesas' },
  { path: '/delivery-costs', label: 'Costos a Domicilio' }
]);
</script>
